import React, { Fragment, ReactElement } from "react";
import { useLocation, useParams, useSearchParams } from "wouter";
import { Panel } from "../../../components/src/common/Panel";

import { useQueryState } from "../../../components/src/use-query-state";
import { DateForm } from "../../../components/src/dateForm";
import { MiniTransactionForm, miniTransactionTypes, NewMiniTransactionButton } from "./MiniTransactionForm";
import { DealBlotterGrid } from "./DealBlotterGrid";
import { serializeSwedenDate } from "../../../components/src/dateFormater";
import { useQuery } from "urql";
import { PermissionAssetEnum } from "../types.generated";
import { GET_ME } from "../common/queries";

export function DealBlotterPage(): ReactElement {
    const [startDate] = useQueryState("startDate", serializeSwedenDate(new Date(new Date().getFullYear() - 1, 0, 1)));

    const [{ fetching: loadingMe, error: errorMe, data }] = useQuery({
        query: GET_ME,
        requestPolicy: "network-only"
    });

    const params = useParams<{ id: string }>();
    const [queryArgs] = useSearchParams();
    const [, navigate] = useLocation();

    if (errorMe)
        return (
            <div>
                <p>Error:</p>
                <pre> {JSON.stringify(errorMe, null, 2)}</pre>
            </div>
        );

    if (loadingMe) return <div>Loading...</div>;

    let id = params.id;

    let type = miniTransactionTypes[0];

    if (id) {
        if (id.startsWith("new")) {
            type = miniTransactionTypes.find((d) => d.toLowerCase() === id.substring(3, id.length));
            id = "new";
        }
    }

    return (
        <Fragment>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full md:w-6/12 px-2 flex">
                    <DateForm defaultDateString={startDate} dateName={"startDate"}></DateForm>
                </div>
                <div className="w-full md:w-6/12 px-2 text-right mb-4">
                    {data &&
                    data.me &&
                    data.me.frontendRole &&
                    data.me.frontendRole.assets &&
                    (data.me.frontendRole.assets.includes(PermissionAssetEnum.BackOffice) || data.me.frontendRole.assets.length === 0) ? (
                        <a
                            href="https://github.com/CaptorAB/documents/blob/master/BackOffice/manual/transacation_and_trade_reconciliation.md"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Manual
                        </a>
                    ) : null}
                </div>
            </div>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full px-2 flex">
                    <div className="ml-auto">
                        <NewMiniTransactionButton page="dealblotter" />
                    </div>
                </div>
            </div>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full px-2">
                    <DealBlotterGrid startDate={startDate} />
                </div>
            </div>

            <Panel
                isOpen={id != null}
                onDismiss={() => {
                    if (queryArgs.toString()) {
                        navigate(`/dealblotter?${queryArgs.toString()}`);
                    } else {
                        navigate("/dealblotter");
                    }
                }}
            >
                {id ? <MiniTransactionForm id={id === "new" ? null : id} type={id === "new" ? type : null} showHeader /> : null}
            </Panel>
        </Fragment>
    );
}
